import {
    setCookie,
    getCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    initLoadGallery,
    faqService
} from './functions';



import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import SplitType from 'split-type';

const gsapAnimIMage = (imageHolder) => {
    const image = imageHolder.querySelector(':scope img');
    gsap.fromTo(image, {
        y: imageHolder.offsetHeight - image.offsetHeight,
        ease: 'power2.inOut',
        duration: 4
    }, {
        scrollTrigger: {
            trigger: imageHolder,
            start: "top 95%",
            end: "bottom 10%",
            scrub: true,
            // markers: true,
            // once: true
        },
        y: 0,
        ease: 'power2.inOut'
    });
}

const gsapCursor = () => {
    const circle = document.querySelector('.cursorCircle');
    const follow = document.querySelector('.cursorCircle-follow');

    const moveCircle = (e) => {
        gsap.to(circle, {
            x: e.clientX,
            y: e.clientY,
            duration: 0.1,
        });
        gsap.to(follow, {
            x: e.clientX,
            y: e.clientY,
            duration: 0.6,
        });
    }
    const onMouseOver = (e) => {

        gsap.to(circle, {
            opacity: 0.5,
            scale: 0.4
        });
        gsap.to(follow, {
            scale: 3
        });
    }
    const onMouseOut = (e) => {

        gsap.to(circle, {
            opacity: 1,
            scale: 1
        });
        gsap.to(follow, {
            scale: 1
        });
    }
    const onMouseDown = () => {
        gsap.to(follow, {
            scale: 0.5
        });
    }
    const onMouseUp = () => {
        gsap.to(follow, {
            scale: 3
        });
    }



    if (circle) {
        window.addEventListener('mousemove', moveCircle);
    }
    if (follow) {
        const fAnchors = document.querySelectorAll('a, button, input, select, textarea');


        const nodeArray = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];
        $('body').on('mouseover', 'a, button, input, select, textarea', onMouseOver);
        $('body').on('mouseout', 'a, button, input, select, textarea', onMouseOut);
        // document.addEventListener('mouseover', (e) => { nodeArray.includes(e.target.nodeName) ? onMouseOver(e) : false });
        // document.addEventListener('mouseout', (e) => nodeArray.includes(e.target.nodeName) ? onMouseOut(e) : false);
        document.addEventListener('mousedown', (e) => nodeArray.includes(e.target.nodeName) ? onMouseDown(e) : false);
        document.addEventListener('mouseup', (e) => nodeArray.includes(e.target.nodeName) ? onMouseUp(e) : false);
    }


}

const mainApp = () => {




    //  window.addEventListener('resize', () => {
    if (window.innerWidth > 992)
        smoothScroll("#pageInner");


    // });
    //  window.dispatchEvent(new Event('resize'));


    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    //aosConfig();

    // add scroll class to body  
    addScollClass('100px', 'scroll');

    // add paralax to element
    //addParalax('.paralax');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();
    initLoadGallery((imageHolder) => {
        const imgH = document.querySelectorAll('.loadedByAjax');
        if (imgH.length > 0) {

            [...imgH].forEach((item) => {
                gsapAnimIMage(item);
                item.classList.remove('loadedByAjax');
            });
        }
        ScrollTrigger.refresh(true);
    });

    faqService();


}



document.addEventListener("DOMContentLoaded", mainApp, false);




(function ($) {
    const mainAppWithJquery = () => {
        if ($('.intro').length > 0 && !getCookie('introShow2')) {


            const intro = gsap.timeline();
            //intro.from('#SVGID_2_', { y: window.innerHeight, duration: 3, delay: 0.4, ease: "power3.inOut" });
            $('.intro').css('opacity', 1);
            $('.intro svg').css('opacity', 1);
            intro.from('#LogoSvg', {
                opacity: 0,
                //scale: 0.95,
                //y: -30,
                //"clip-path": "polygon(0px 100%, 100% 100%, 100% 100%, 0px 100%)",
                duration: 2.5,
                delay: 0.1,
                ease: "power1.in"
            });
            intro.to('.intro', {
                duration: 1, opacity: 0, delay: 0.6, onComplete: function () {
                    setCookie('introShow2', 1);
                    $('.intro').css({ visibility: 'hidden' });
                    $('.intro svg').css({ visibility: 'hidden' });

                }
            });

        } else {

            gsap.to('.intro', {
                duration: 1, opacity: 0, onComplete: function () {

                    $('.intro').css('visibility', 'hidden');

                }
            });
        }

        $('a[href*="' + location.host + '"]:not([href$=".jpg"]):not([href$=".png"]):not([href$=".gif"]):not([href$=".pdf"]):not([href$=".txt"]):not([href$=".doc"]):not([href$=".docx"]):not([href$=".odt"]):not([href$=".odf"]):not([target="_blank"])')
            .click(function (e) {
                if (!e.ctrlKey) {
                    $('.intro').css('visibility', 'visible');
                    //$('.intro svg').css('opacity', 1);
                    gsap.to('.intro', {
                        duration: 0.5, opacity: 1
                    });
                }
            });



        const imgeList = document.querySelectorAll('.galleryPage__imageHolder, .indexC4__boxImageHolder, .indexC3__imageHolder');

        if (imgeList.length > 0) {
            [...imgeList].forEach((imageHolder) => gsapAnimIMage(imageHolder));
        }


        if (document.querySelector('.page-template-mainsite')) {

            var splitContent2 = new SplitType('.indexC1__slogan', {
                split: 'lines',
                tagName: 'span',
                // position: 'absolute'
            });
            $.each(splitContent2.lines, function (i, e) {
                $(e).wrapInner('<span></span>');
            });


            gsap.from('.indexC1__slogan  .line span',
                {

                    duration: 1,
                    stagger: 0.1,
                    y: "100%",
                    scrollTrigger: {
                        trigger: ".indexC1",
                        start: "top 50%",
                        // stagger: 1,
                        toggleActions: 'play play play play',
                        end: "bottom bottom",
                        //markers: true,
                        //once: true,
                        scrub: true,
                    }
                }
            );

            gsap.fromTo('.indexC1__slogan', {
                yPercent: -100,

                ease: 'power2.inOut',
                duration: 4
            }, {
                scrollTrigger: {
                    trigger: '.indexC1',
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    //markers: true,
                    // once: true
                },
                yPercent: 120,

                ease: 'power2.inOut'
            });
            gsap.fromTo('.indexC1__bg', {
                opacity: 1,

                ease: 'power2.inOut',
                duration: 4
            }, {
                scrollTrigger: {
                    trigger: '.indexC1',
                    start: "top 50%",
                    end: "bottom bottom",
                    scrub: true,
                    //markers: true,
                    // once: true
                },
                opacity: 0,

                ease: 'power2.out'
            });




        } else {
            var splitContent3 = new SplitType('.subpageHeader__title', {
                split: 'lines',
                tagName: 'span',
                // position: 'absolute'
            });
            $.each(splitContent3.lines, function (i, e) {
                $(e).wrapInner('<span></span>');



            });

            gsap.fromTo('.subpageHeader__title  .line span',
                {

                    y: "100%",
                    opacity: 0,
                },
                {
                    delay: 0.2,
                    duration: 2,
                    stagger: 0.1,
                    opacity: 1,
                    y: "0%",
                    ease: "power3.out",

                }
            );




        }

        const animList = document.querySelectorAll('.indexC3__imageHolder, .indexC3__content, .indexC4__content, .indexC4__box, .indexC2__content, .indexC2__videoHolder, .indexC5__content, .indexC5__galleryList,  .testimonials:not(.allWidth) .testimonials__item  ');

        if (animList.length > 0) {
            [...animList].forEach((item) => {
                gsap.from(item, {
                    opacity: 0,
                    y: 30,
                    duration: 2,
                    scrollTrigger: {
                        trigger: item,
                        start: "top 75%",
                        end: "bottom bottom",
                        // scrub: true,
                        //markers: true,
                        once: true
                    },
                });

            });
        }








        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                autoplaySpeed: 6000,
                fade: true,
                //cssEase: 'linear'
            });

            var splitContentRotator = new SplitType('.rotator__h2text', {
                split: 'lines',
                tagName: 'span',
                // position: 'absolute'
            });
            $.each(splitContentRotator.lines, function (i, e) {
                $(e).wrapInner('<span></span>');
            });




            var currentRotSlide = 0;
            $('.rotatorTop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                //currentRotSlide = currentSlide;
                //  $('.rotatorTop .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
                //var currentSlide = $('.rotatorTop').slick('slickCurrentSlide');
                gsap.fromTo('.rotatorTop .rotator__slide:nth-child(' + (nextSlide + 1) + ')  .line span',
                    {

                        y: "100%",
                        opacity: 0,
                    },
                    {
                        delay: 0.2,
                        duration: 2,
                        stagger: 0.1,
                        opacity: 1,
                        y: "0%",
                        ease: "power3.out",
                    }
                );
            });
            $('.rotatorTop').on('afterChange', function (event, slick, currentSlide, nextSlide) {

                // $('.rotatorTop .rotator__slide:nth-child(' + (currentRotSlide + 1) + ')').removeClass('slick-out');
            });



        }

        if ($('.indexC5__galleryList').length > 0) {
            $('.indexC5__galleryList').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 800,
                autoplaySpeed: 5000,
            });

        }

        if ($('.mySlider').length > 0) {
            $('.mySlider').slick({
                infinite: false,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 800,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });

        }


        if ($('.wp-block-gallery').length > 0) {
            $('.wp-block-gallery').each(function (i) {
                let newGallery = $('<div class="newGallery"><h3 class="newGallery__header">' +
                    $(this).find('.blocks-gallery-caption').text() +
                    '</h3><div  class="newGallery__slider mySlider slickSliderUi"></div></div>');
                let tempItem = '';
                let gallery = $(this).find('.blocks-gallery-item figure, .wp-block-image');
                console.log(gallery);
                gallery.each(function (index) {

                    tempItem += $(this).html();
                    let newItem = $('<div class="newGallery__slide"></div>');
                    newItem.append(tempItem);
                    newGallery.find('.newGallery__slider').append(newItem);
                    tempItem = '';

                });
                $(this).before(newGallery);
                var idGal = 'gal' + (Math.floor(Math.random() * 100));
                newGallery.find('a').each(function () {
                    $(this).attr('data-fancybox', idGal);
                    $(this).find('img').removeAttr('loading');
                    $(this).attr('data-caption', $(this).next('figcaption').html());

                });
                $(this).remove();

            });



        }


        $('.newGallery__slider').slick({
            infinite: true,
            arrows: true,
            dots: false,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 10000,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });






        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a, .newGallery__slider a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
            backFocus: false,
            thumbs: {
                autoStart: true, // Display thumbnails on opening
                hideOnClose: true, // Hide thumbnail grid when closing animation starts
                parentEl: ".fancybox-container", // Container is injected into this element
                axis: "y" // Vertical (y) or horizontal (x) scrolling
            }
        });

        if (window.innerWidth > 992)
            gsapCursor();
    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);


function smoothScroll(content, viewport, smoothness) {
    content = gsap.utils.toArray(content)[0];
    smoothness = smoothness || 1;

    gsap.set(viewport || content.parentNode, { overflow: "hidden", position: "fixed", height: "100%", width: "100%", top: 0, left: 0, right: 0, bottom: 0 });
    gsap.set(content, { overflow: "visible", width: "100%" });

    let getProp = gsap.getProperty(content),
        setProp = gsap.quickSetter(content, "y", "px"),
        setScroll = ScrollTrigger.getScrollFunc(window),
        removeScroll = () => content.style.overflow = "visible",
        killScrub = trigger => {
            let scrub = trigger.getTween ? trigger.getTween() : gsap.getTweensOf(trigger.animation)[0]; // getTween() was added in 3.6.2
            scrub && scrub.kill();
            trigger.animation.progress(trigger.progress);
        },
        height, isProxyScrolling;

    function onResize() {
        height = content.clientHeight;
        content.style.overflow = "visible"
        document.body.style.height = height + "px";
    }
    onResize();
    ScrollTrigger.addEventListener("refreshInit", onResize);
    ScrollTrigger.addEventListener("refresh", () => {
        removeScroll();
        requestAnimationFrame(removeScroll);
    })
    ScrollTrigger.defaults({ scroller: content });
    ScrollTrigger.prototype.update = p => p; // works around an issue in ScrollTrigger 3.6.1 and earlier (fixed in 3.6.2, so this line could be deleted if you're using 3.6.2 or later)

    ScrollTrigger.scrollerProxy(content, {
        scrollTop(value) {
            if (arguments.length) {
                isProxyScrolling = true; // otherwise, if snapping was applied (or anything that attempted to SET the scroll proxy's scroll position), we'd set the scroll here which would then (on the next tick) update the content tween/ScrollTrigger which would try to smoothly animate to that new value, thus the scrub tween would impede the progress. So we use this flag to respond accordingly in the ScrollTrigger's onUpdate and effectively force the scrub to its end immediately.
                setProp(-value);
                setScroll(value);
                return;
            }
            return -getProp("y");
        },
        getBoundingClientRect() {
            return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
        }
    });

    return ScrollTrigger.create({
        animation: gsap.fromTo(content, { y: 0 }, {
            y: () => document.documentElement.clientHeight - height,
            ease: "none",
            onUpdate: ScrollTrigger.update
        }),
        scroller: window,
        invalidateOnRefresh: true,
        start: 0,
        end: () => height - document.documentElement.clientHeight,
        scrub: smoothness,
        onUpdate: self => {
            if (isProxyScrolling) {
                killScrub(self);
                isProxyScrolling = false;
            }
        },
        onRefresh: killScrub // when the screen resizes, we just want the animation to immediately go to the appropriate spot rather than animating there, so basically kill the scrub.
    });
}
